import { render, staticRenderFns } from "./PcDragDropFileUpload.vue?vue&type=template&id=3901cdfa"
import script from "./PcDragDropFileUpload.vue?vue&type=script&lang=js"
export * from "./PcDragDropFileUpload.vue?vue&type=script&lang=js"
import style0 from "./PcDragDropFileUpload.vue?vue&type=style&index=0&id=3901cdfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports